import React, { useRef, useEffect } from "react";
import { Animated, Dimensions, Easing } from "react-native";
import { EStyleSheet, useDynamicStyles } from "react-native-extended-stylesheet-typescript";

interface Props {
    direction: number;
    complete: boolean;
}
export const AnimatedFree: React.FC<Props> = (props) => {
    const screenWidth = Dimensions.get("window").width * props.direction;
    const translate = useRef(new Animated.Value(screenWidth)).current;
    const opacity = useRef(new Animated.Value(0)).current;
    const styles = useDynamicStyles(calculateStyles);

    useEffect(() => {
        Animated.timing(translate, {
            toValue: 0,
            useNativeDriver: true,
            duration: 750,
            easing: Easing.out(Easing.back(1)),
        }).start();
    }, [translate]);

    useEffect(() => {
        Animated.timing(opacity, {
            toValue: 1,
            useNativeDriver: true,
            duration: 600,
        }).start();
    }, [opacity]);

    return (
        <Animated.View style={[styles.animatedContainer, { left: translate, opacity }]}>{props.children}</Animated.View>
    );
};
const calculateStyles = () => {
    return EStyleSheet.create({
        animatedContainer: {
            alignSelf: "stretch",
            position: "relative",
            zIndex: 1,
        },
    });
};
